<template>
  <div class="firstDiv">
    <div
      class="swiper-button-prev btn"
      style="left: 0px;"
      slot="button-prev"
    ></div>
    <div
      class="swiper-button-next btn"
      style="right: 0px"
      slot="button-next"
    ></div>
    <div class="centerDiv">
      <div class="thumb-example">
        <!-- 大轮播图 -->
        <swiper
          class="swiper gallery-top"
          :options="swiperOptionTop"
          ref="swiperTop"
        >
          <swiper-slide
            v-for="(item, index) in swiperList"
            :key="index"
            :style="{ backgroundImage: `url(${item.imgs})`,borderRadius:'8px' }"
          ></swiper-slide>
        </swiper>
        <!-- 小缩略图 -->
        <swiper
          class="swiper gallery-thumbs"
          :options="swiperOptionThumbs"
          ref="swiperThumbs"
        >
          <swiper-slide
            v-for="(item, index) in swiperList"
            :key="index"
            :style="{ backgroundImage: `url(${item.imgs})`,borderRadius:'8px' }"
          ></swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>
 
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "image",
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    swiperList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      swiperOptionTop: {
        loop: true,
        loopedSlides: 8, // looped slides should be the same
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 8, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
    };
  },

  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.swiper;
      const swiperThumbs = this.$refs.swiperThumbs.swiper;
      console.log(this.$refs);
      swiperTop.controller.control = swiperThumbs;
      swiperThumbs.controller.control = swiperTop;
    });
  },
};
</script>
 
<style scoped lang="less">
.firstDiv {
  width: 500px;
  height: 400px;
  position: relative;
}

.centerDiv {
  width: 470px;
  height: 300px;
}

.thumb-example {
  height: 400px;
  background-color: transparent;
}

.swiper-slide {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
}
.btn {
  width: 30px;
  height: 30px;
  color: #c4c4c4;
  border: 2px solid #c4c4c4;
  position: absolute;
  top: 92%;
  &::after {
    font-size: 18px !important;
  }
}
.slide {
  background-image: url("../../../assets/111111.jpeg");
}

.gallery-top {
  height: 80%;
  width: 100%;
}
.gallery-thumbs {
  height: 20%;
  box-sizing: border-box;
  padding: 10px 0;
}
.gallery-thumbs .swiper-slide {
  width: 20%;
  height: 100%;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
</style>
 
 
 
 


// WEBPACK FOOTER //
// src/components/product/components/swiperBox.vue